import bits from './bits';
import buffer from './buffer';
import byte from './byte';
import integer from './integer';
import nibble from './nibble';
import string from './string';
export { bits, buffer, byte, integer, nibble, string };
var bitwise = {
  bits: bits,
  buffer: buffer,
  byte: byte,
  integer: integer,
  nibble: nibble,
  string: string
};
export default bitwise;